<template>
  <div>
    <slot />
  </div>
</template>

<script>
export default {
  async mounted () {
    // let hubSpotFrame = document.getElementById('hubspot-messages-iframe-container')
    // if(hubSpotFrame !== null || hubSpotFrame !== undefined){
    //   let newData = document.getElementById('hubspot-messages-iframe-container')
    //   newData.style.display = 'none'
    //   newData.style.width = '0px'
    //   newData.style.height = '0px'
    // }
    const hideSociomile = time => new Promise(resolve => setTimeout(() => {
      let sociomile = document.getElementsByClassName('custom_widget')[0]
      if (sociomile) {
        sociomile.style.display = 'none'
        resolve(true)
      } else {
        resolve(false)
      }
    }, time))

    this.$store.commit('SET_ENV_BELAJAR')
    this.$store.commit('SET_ACTIVE_ENVIRONMENT')
    this.$store.dispatch('subnavbar/initMenuList')
    for (let i = 0; i < 5; i++) {
      const sociomile = await hideSociomile(300)
      if (sociomile) {
        break
      }
    }
  }
}
</script>

<style>
</style>
